<template>
    <GenericModal
        modal-title="Choose Consultation Type"
        size="modal-lg"
        @hidden=""
    >
        <template #activator="{ show }">
            <slot name="activator" :show="show">
                <div @click="show" class="btn btn-lg btn-dark px-4 py-2 hstack gap-3">
                    <Icon symbol="paper" size="m"></Icon>
                    <span>New Consultation</span>
                </div>
            </slot>
        </template>
        <template v-slot="{ hide }">
            <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 p-4">
                <div class="col">
                    <router-link :to="{name: 'customer-details'}" class="selection-button-item btn position-relative w-100">
                        Full Consultation
                    </router-link>
                </div>
                <div class="col">
                    <router-link :to="{name: 'pre-consultation.customer-details'}" class="selection-button-item btn position-relative w-100">
                        Pre-consultation
                    </router-link>
                </div>
                <div class="col">
                    <router-link :to="{name: 'simple-consultation.customer-details'}" class="selection-button-item btn position-relative w-100">
                        Routine Builder
                    </router-link>
                </div>
            </div>
        </template>
    </GenericModal>
</template>

<script setup lang="ts">
import { GenericModal } from '@/modules/core/components';
import { Icon } from '@/modules/core/components';
</script>